var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsights(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 62,
    viewBox: "0 0 206 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2134_119546)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 62,
    transform: "translate(0.875)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2134_119546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.8745 37L47.81 38.8438L49.939 38.8438L48.8745 37ZM48.6901 67C48.6901 67.1018 48.7727 67.1844 48.8745 67.1844C48.9763 67.1844 49.0589 67.1018 49.0589 67L48.6901 67ZM48.6901 38.6594L48.6901 67L49.0589 67L49.0589 38.6594L48.6901 38.6594Z",
    fill: "#3D3D3D",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8911 40.8203L35.7621 40.8203L36.8266 42.6641L37.8911 40.8203ZM20.2347 50.8013C20.1465 50.8523 20.1163 50.965 20.1672 51.0532C20.2181 51.1414 20.3309 51.1716 20.4191 51.1207L20.2347 50.8013ZM36.3619 41.4903L20.2347 50.8013L20.4191 51.1207L36.5462 41.8097L36.3619 41.4903Z",
    fill: "#3D3D3D",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9817 11.1511C84.0646 11.0926 84.084 10.9775 84.0251 10.8941C83.9662 10.8106 83.8512 10.7904 83.7683 10.8489L83.9817 11.1511ZM49.875 35L51.9917 34.8131L50.7599 33.0681L49.875 35ZM83.7683 10.8489L51.119 33.8954L51.3324 34.1977L83.9817 11.1511L83.7683 10.8489Z",
    fill: "#3D3D3D",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.875 35L48.0067 33.0633L46.7614 34.8068L48.875 35ZM13.9828 9.84901C13.9005 9.79019 13.7855 9.81011 13.7259 9.8935C13.6663 9.97689 13.6848 10.0922 13.7671 10.151L13.9828 9.84901ZM47.641 33.8906L13.9828 9.84901L13.7671 10.151L47.4253 34.1925L47.641 33.8906Z",
    fill: "#3D3D3D",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.578 1.1792C118.578 1.07737 118.496 0.994823 118.394 0.994823C118.292 0.994823 118.21 1.07737 118.21 1.1792L118.578 1.1792ZM118.394 22.1981L119.459 20.3544L117.33 20.3544L118.394 22.1981ZM118.21 1.1792L118.21 20.5387L118.578 20.5387L118.578 1.1792L118.21 1.1792Z",
    fill: "#3D3D3D",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.216 40.8203L105.087 40.7696L106.105 42.6375L107.216 40.8203ZM84.7863 52.8384C84.6968 52.8871 84.6638 52.9991 84.7125 53.0884C84.7612 53.1778 84.8732 53.2107 84.9627 53.1619L84.7863 52.8384ZM105.67 41.4535L84.7863 52.8384L84.9627 53.1619L105.846 41.777L105.67 41.4535Z",
    fill: "#3D3D3D",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.875 35L117.995 33.0681L116.76 34.8179L118.875 35ZM84.982 10.8485C84.8993 10.7901 84.7843 10.8106 84.7253 10.8943C84.6662 10.978 84.6853 11.0932 84.768 11.1515L84.982 10.8485ZM117.634 33.8972L84.982 10.8485L84.768 11.1515L117.42 34.2002L117.634 33.8972Z",
    fill: "#3D3D3D",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.875 35L120.269 36.6199L120.982 34.6443L118.875 35ZM154.813 48.1711C154.91 48.206 155.016 48.1577 155.05 48.0632C155.084 47.9687 155.033 47.8638 154.937 47.8289L154.813 48.1711ZM120.389 35.74L154.813 48.1711L154.937 47.8289L120.512 35.3978L120.389 35.74Z",
    fill: "#3D3D3D",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.932 44.1855L188.868 46.0293L190.997 46.0293L189.932 44.1855ZM189.748 62.6391C189.748 62.741 189.83 62.8235 189.932 62.8235C190.034 62.8235 190.117 62.741 190.117 62.6391L189.748 62.6391ZM189.748 45.8449L189.748 62.6391L190.117 62.6391L190.117 45.8449L189.748 45.8449Z",
    fill: "#3D3D3D",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.063 -8.55874e-09C190.063 -0.103586 189.978 -0.18756 189.875 -0.18756C189.771 -0.18756 189.686 -0.103586 189.686 8.55874e-09L190.063 -8.55874e-09ZM189.875 23L190.961 21.1244L188.788 21.1244L189.875 23ZM189.686 8.55874e-09L189.686 21.312L190.063 21.312L190.063 -8.55874e-09L189.686 8.55874e-09Z",
    fill: "#3D3D3D",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.875 33L187.759 32.7534L188.594 34.7024L189.875 33ZM154.803 47.8312C154.709 47.8714 154.665 47.9796 154.705 48.0728C154.745 48.166 154.854 48.209 154.947 48.1688L154.803 47.8312ZM188.274 33.4863L154.803 47.8312L154.947 48.1688L188.419 33.8239L188.274 33.4863Z",
    fill: "#3D3D3D",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.875 33L187.59 31.261L186.716 33.1188L188.875 33ZM154.95 16.8392C154.855 16.7944 154.744 16.8302 154.702 16.9191C154.661 17.0079 154.704 17.1162 154.799 17.161L154.95 16.8392ZM187.401 32.11L154.95 16.8392L154.799 17.161L187.249 32.4318L187.401 32.11Z",
    fill: "#3D3D3D",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.263 38.4811C281.547 38.4812 281.547 38.4812 281.263 38.4811C280.98 38.481 280.519 38.4809 280.236 38.4808L281.263 38.4811ZM138.686 38.4442L146.79 38.4463L140.857 38.4447L138.686 38.4442ZM280.236 38.4808L142.796 38.4452L143.824 38.4455L281.263 38.4811L280.236 38.4808Z",
    fill: "#3D3D3D",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 190.044,
    cy: 32.0698,
    r: 14.875,
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.044 17.1948C187.922 17.1948 185.826 17.6486 183.894 18.5257C181.962 19.4029 180.24 20.683 178.844 22.2803L190.044 32.0698V17.1948Z",
    fill: "#FB6C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.526 42.5875C176.865 39.9266 175.311 36.356 175.178 32.5953C175.045 28.8346 176.342 25.1632 178.809 22.3209L190.044 32.0693L179.526 42.5875Z",
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.044,
    cy: 32.0693,
    r: 13.9453,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.373 31.6787C184.056 31.8782 183.846 32.2309 183.846 32.6326V33.1397C183.846 33.5331 184.048 33.8794 184.353 34.081V34.2103C184.353 35.7662 185.615 37.0275 187.17 37.0275H192.918C194.474 37.0275 195.735 35.7662 195.735 34.2103V34.081C196.04 33.8794 196.242 33.5331 196.242 33.1397V32.6326C196.242 32.2308 196.032 31.8782 195.715 31.6786C195.489 29.1185 193.34 27.1108 190.721 27.1108H189.367C186.749 27.1108 184.599 29.1185 184.373 31.6787ZM190.721 27.787H189.368C187.25 27.787 185.487 29.3039 185.106 31.3102L185.082 31.4488H195.006C194.686 29.4137 192.959 27.856 190.861 27.7892L190.721 27.787ZM184.973 32.1819H190.871L191.949 33.2596C192.016 33.3262 192.103 33.3592 192.19 33.3586C192.277 33.3589 192.364 33.3259 192.43 33.2596L193.508 32.1819H195.115L195.172 32.1854C195.394 32.2132 195.566 32.4028 195.566 32.6326V33.1397L195.562 33.1963C195.535 33.4185 195.345 33.5905 195.115 33.5905H184.973L184.917 33.587C184.694 33.5591 184.522 33.3695 184.522 33.1397V32.6326L184.526 32.5761C184.554 32.3538 184.743 32.1819 184.973 32.1819ZM192.552 32.1819H191.828L192.19 32.5441L192.552 32.1819ZM185.032 34.3218H195.056L195.048 34.4292C194.938 35.5088 194.026 36.3514 192.918 36.3514H187.171L187.06 36.3486C186.002 36.2949 185.147 35.4729 185.041 34.4292L185.032 34.3218Z",
    fill: "#3D3D3D",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5122,
    cy: 35.3623,
    r: 14.875,
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5122 20.4873C47.3907 20.4873 45.2938 20.9411 43.3621 21.8182C41.4305 22.6953 39.7088 23.9755 38.3126 25.5728L49.5122 35.3623V20.4873Z",
    fill: "#FB6C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.994 45.88C36.3331 43.2191 34.7796 39.6485 34.6465 35.8878C34.5134 32.1271 35.8107 28.4557 38.2768 25.6133L49.5122 35.3618L38.994 45.88Z",
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5122,
    cy: 35.3618,
    r: 13.9453,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8411 34.9712C43.5247 35.1707 43.3145 35.5233 43.3145 35.9251V36.4322C43.3145 36.8256 43.516 37.1719 43.8215 37.3734V37.5027C43.8215 39.0587 45.0828 40.32 46.6387 40.32H52.3859C53.9418 40.32 55.2031 39.0587 55.2031 37.5027V37.3735C55.5086 37.1719 55.7103 36.8256 55.7103 36.4322V35.9251C55.7103 35.5233 55.5 35.1707 55.1835 34.9711C54.9577 32.411 52.8078 30.4033 50.189 30.4033H48.8356C46.2168 30.4033 44.0669 32.411 43.8411 34.9712ZM50.1891 31.0794H48.8358C46.7184 31.0794 44.9554 32.5964 44.5742 34.6027L44.5502 34.7413H54.4747C54.1546 32.7062 52.4268 31.1484 50.3295 31.0817L50.1891 31.0794ZM44.4415 35.4743H50.3396L51.4174 36.5521C51.484 36.6187 51.5714 36.6517 51.6587 36.6511C51.7456 36.6514 51.8324 36.6183 51.8987 36.5521L52.9764 35.4743H54.5835L54.64 35.4779C54.8623 35.5057 55.0342 35.6953 55.0342 35.9251V36.4322L55.0307 36.4887C55.0029 36.711 54.8133 36.883 54.5835 36.883H44.4415L44.3849 36.8794C44.1627 36.8516 43.9907 36.662 43.9907 36.4322V35.9251L43.9942 35.8686C44.022 35.6463 44.2117 35.4743 44.4415 35.4743ZM52.0202 35.4743H51.2958L51.658 35.8366L52.0202 35.4743ZM44.5 37.6143H54.5243L54.516 37.7217C54.4064 38.8013 53.4946 39.6438 52.386 39.6438H46.6389L46.5287 39.6411C45.4704 39.5874 44.6148 38.7653 44.5088 37.7217L44.5 37.6143Z",
    fill: "#3D3D3D",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.853,
    cy: 35.0092,
    r: 14.875,
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.853 20.1343C116.732 20.1343 114.635 20.5881 112.703 21.4652C110.772 22.3423 109.05 23.6225 107.654 25.2198L118.853 35.0092V20.1343Z",
    fill: "#FB6C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.335 45.5269C105.674 42.866 104.121 39.2955 103.988 35.5348C103.855 31.774 105.152 28.1026 107.618 25.2603L118.853 35.0087L108.335 45.5269Z",
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.853,
    cy: 35.0088,
    r: 13.9453,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.182 34.6182C112.866 34.8177 112.656 35.1703 112.656 35.5721V36.0792C112.656 36.4725 112.857 36.8188 113.163 37.0204V37.1497C113.163 38.7056 114.424 39.9669 115.98 39.9669H121.727C123.283 39.9669 124.544 38.7056 124.544 37.1497V37.0205C124.85 36.8189 125.052 36.4726 125.052 36.0792V35.5721C125.052 35.1703 124.841 34.8176 124.525 34.6181C124.299 32.058 122.149 30.0503 119.53 30.0503H118.177C115.558 30.0503 113.408 32.058 113.182 34.6182ZM119.53 30.7264H118.177C116.06 30.7264 114.297 32.2433 113.915 34.2497L113.891 34.3882H123.816C123.496 32.3532 121.768 30.7954 119.671 30.7286L119.53 30.7264ZM113.783 35.1213H119.681L120.759 36.1991C120.825 36.2657 120.913 36.2987 121 36.2981C121.087 36.2983 121.174 36.2653 121.24 36.1991L122.318 35.1213H123.925L123.981 35.1248C124.204 35.1526 124.376 35.3423 124.376 35.5721V36.0792L124.372 36.1357C124.344 36.358 124.155 36.5299 123.925 36.5299H113.783L113.726 36.5264C113.504 36.4986 113.332 36.309 113.332 36.0792V35.5721L113.336 35.5155C113.363 35.2933 113.553 35.1213 113.783 35.1213ZM121.362 35.1213H120.637L120.999 35.4835L121.362 35.1213ZM113.841 37.2613H123.866L123.857 37.3686C123.748 38.4483 122.836 39.2908 121.727 39.2908H115.98L115.87 39.288C114.812 39.2344 113.956 38.4123 113.85 37.3686L113.841 37.2613Z",
    fill: "#3D3D3D",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.2446,
    cy: 9.92478,
    r: 8.85007,
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2446 1.07471C12.9824 1.07471 11.7348 1.3447 10.5855 1.86655C9.43627 2.38841 8.41193 3.15006 7.58125 4.10039L14.2446 9.92478V1.07471Z",
    fill: "#FB6C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98666 16.1827C6.40352 14.5996 5.47924 12.4752 5.40007 10.2377C5.32089 8.00024 6.0927 5.81589 7.55999 4.12481L14.2446 9.92478L7.98666 16.1827Z",
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.2446,
    cy: 9.92458,
    r: 8.11257,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9278 6.80056C11.992 6.68074 12.1169 6.60596 12.2528 6.60596H16.2363C16.3722 6.60596 16.4971 6.68074 16.5613 6.80056L17.5633 8.67076V12.8748C17.5633 13.0784 17.3982 13.2435 17.1946 13.2435H11.2945C11.0909 13.2435 10.9258 13.0784 10.9258 12.8748V8.67076L11.9278 6.80056ZM12.3166 7.06791C12.3231 7.05593 12.3356 7.04845 12.3491 7.04845H14.0233V8.58376H11.5045L12.3166 7.06791ZM14.4658 8.58376H16.9846L16.1725 7.06791C16.1661 7.05593 16.1536 7.04845 16.14 7.04845H14.4658V8.58376ZM11.3683 9.02626H17.1209V12.7643C17.1209 12.7847 17.1044 12.8012 17.084 12.8012H11.4052C11.3848 12.8012 11.3683 12.7847 11.3683 12.7643V9.02626Z",
    fill: "#3D3D3D",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.2446,
    cy: 50.8564,
    r: 8.85007,
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2446 42.0063C12.9824 42.0063 11.7348 42.2763 10.5855 42.7982C9.43627 43.3201 8.41193 44.0817 7.58125 45.032L14.2446 50.8564V42.0063Z",
    fill: "#FB6C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98666 57.1144C6.40352 55.5312 5.47924 53.4069 5.40007 51.1694C5.32089 48.9319 6.0927 46.7475 7.55999 45.0564L14.2446 50.8564L7.98666 57.1144Z",
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.2446,
    cy: 50.8562,
    r: 8.11257,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9278 47.7322C11.992 47.6124 12.1169 47.5376 12.2528 47.5376H16.2363C16.3722 47.5376 16.4971 47.6124 16.5613 47.7322L17.5633 49.6024V53.8064C17.5633 54.0101 17.3982 54.1752 17.1946 54.1752H11.2945C11.0909 54.1752 10.9258 54.0101 10.9258 53.8064V49.6024L11.9278 47.7322ZM12.3166 47.9996C12.3231 47.9876 12.3356 47.9801 12.3491 47.9801H14.0233V49.5154H11.5045L12.3166 47.9996ZM14.4658 49.5154H16.9846L16.1725 47.9996C16.1661 47.9876 16.1536 47.9801 16.14 47.9801H14.4658V49.5154ZM11.3683 49.9579H17.1209V53.6959C17.1209 53.7163 17.1044 53.7328 17.084 53.7328H11.4052C11.3848 53.7328 11.3683 53.7163 11.3683 53.6959V49.9579Z",
    fill: "#3D3D3D",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.2094,
    cy: 10.5224,
    r: 8.85007,
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2094 1.67236C82.9472 1.67236 81.6996 1.94235 80.5504 2.46421C79.4011 2.98607 78.3768 3.74772 77.5461 4.69805L84.2094 10.5224V1.67236Z",
    fill: "#FB6C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9515 16.7804C76.3684 15.1972 75.4441 13.0729 75.3649 10.8354C75.2857 8.5979 76.0575 6.41354 77.5248 4.72246L84.2094 10.5224L77.9515 16.7804Z",
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.2092,
    cy: 10.5222,
    r: 8.11257,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.8926 7.39822C81.9568 7.2784 82.0817 7.20361 82.2177 7.20361H86.2011C86.3371 7.20361 86.462 7.2784 86.5262 7.39822L87.5282 9.26842V13.4724C87.5282 13.6761 87.3631 13.8412 87.1594 13.8412H81.2594C81.0557 13.8412 80.8906 13.6761 80.8906 13.4724V9.26842L81.8926 7.39822ZM82.2815 7.66557C82.2879 7.65358 82.3004 7.64611 82.314 7.64611H83.9882V9.18141H81.4694L82.2815 7.66557ZM84.4307 9.18141H86.9495L86.1374 7.66557C86.131 7.65358 86.1185 7.64611 86.1049 7.64611H84.4307V9.18141ZM81.3332 9.62392H87.0857V13.362C87.0857 13.3823 87.0692 13.3988 87.0488 13.3988H81.37C81.3497 13.3988 81.3332 13.3823 81.3332 13.362V9.62392Z",
    fill: "#3D3D3D",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.973,
    cy: 47.334,
    r: 8.85007,
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.973 38.4839C153.711 38.4839 152.463 38.7539 151.314 39.2757C150.165 39.7976 149.14 40.5592 148.31 41.5096L154.973 47.334V38.4839Z",
    fill: "#FB6C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.715 53.5919C147.132 52.0088 146.208 49.8844 146.129 47.6469C146.049 45.4094 146.821 43.2251 148.289 41.534L154.973 47.334L148.715 53.5919Z",
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.973,
    cy: 47.3338,
    r: 8.11257,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.656 44.2097C152.72 44.0899 152.845 44.0151 152.981 44.0151H156.965C157.101 44.0151 157.226 44.0899 157.29 44.2097L158.292 46.0799V50.2839C158.292 50.4876 158.127 50.6527 157.923 50.6527H152.023C151.819 50.6527 151.654 50.4876 151.654 50.2839V46.0799L152.656 44.2097ZM153.045 44.4771C153.052 44.4651 153.064 44.4576 153.078 44.4576H154.752V45.9929H152.233L153.045 44.4771ZM155.194 45.9929H157.713L156.901 44.4771C156.895 44.4651 156.882 44.4576 156.869 44.4576H155.194V45.9929ZM152.097 46.4354H157.849V50.1735C157.849 50.1939 157.833 50.2104 157.813 50.2104H152.134C152.113 50.2104 152.097 50.1939 152.097 50.1735V46.4354Z",
    fill: "#3D3D3D",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.973,
    cy: 17.8501,
    r: 8.85007,
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.973 9C153.711 9 152.463 9.26999 151.314 9.79185C150.165 10.3137 149.14 11.0754 148.31 12.0257L154.973 17.8501V9Z",
    fill: "#FB6C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.715 24.108C147.132 22.5249 146.208 20.4005 146.129 18.163C146.049 15.9255 146.821 13.7412 148.289 12.0501L154.973 17.8501L148.715 24.108Z",
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.973,
    cy: 17.8499,
    r: 8.11257,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.656 14.7259C152.72 14.606 152.845 14.5312 152.981 14.5312H156.965C157.101 14.5312 157.226 14.606 157.29 14.7259L158.292 16.5961V20.8001C158.292 21.0037 158.127 21.1688 157.923 21.1688H152.023C151.819 21.1688 151.654 21.0037 151.654 20.8001V16.5961L152.656 14.7259ZM153.045 14.9932C153.052 14.9812 153.064 14.9737 153.078 14.9737H154.752V16.5091H152.233L153.045 14.9932ZM155.194 16.5091H157.713L156.901 14.9932C156.895 14.9812 156.882 14.9737 156.869 14.9737H155.194V16.5091ZM152.097 16.9516H157.849V20.6896C157.849 20.71 157.833 20.7265 157.813 20.7265H152.134C152.113 20.7265 152.097 20.71 152.097 20.6896V16.9516Z",
    fill: "#3D3D3D",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.1836,
    cy: 51.4179,
    r: 8.85007,
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1836 42.5679C82.9214 42.5679 81.6738 42.8379 80.5245 43.3597C79.3752 43.8816 78.3509 44.6432 77.5202 45.5936L84.1836 51.4179V42.5679Z",
    fill: "#FB6C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9256 57.6759C76.3425 56.0927 75.4182 53.9684 75.339 51.7309C75.2599 49.4934 76.0317 47.3091 77.499 45.618L84.1836 51.4179L77.9256 57.6759Z",
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.1834,
    cy: 51.4177,
    r: 8.11257,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.8667 48.2937C81.9309 48.1739 82.0558 48.0991 82.1918 48.0991H86.1753C86.3112 48.0991 86.4361 48.1739 86.5003 48.2937L87.5023 50.1639V54.3679C87.5023 54.5716 87.3372 54.7367 87.1335 54.7367H81.2335C81.0298 54.7367 80.8647 54.5716 80.8647 54.3679V50.1639L81.8667 48.2937ZM82.2556 48.5611C82.262 48.5491 82.2745 48.5416 82.2881 48.5416H83.9623V50.0769H81.4435L82.2556 48.5611ZM84.4048 50.0769H86.9236L86.1115 48.5611C86.1051 48.5491 86.0926 48.5416 86.079 48.5416H84.4048V50.0769ZM81.3073 50.5194H87.0598V54.2575C87.0598 54.2778 87.0433 54.2943 87.0229 54.2943H81.3442C81.3238 54.2943 81.3073 54.2778 81.3073 54.2575V50.5194Z",
    fill: "#3D3D3D",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2134_119546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 62,
    fill: "white",
    transform: "translate(0.875)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2134_119546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 241,
    height: 205.279,
    fill: "white",
    transform: "translate(-2.125 -74.7036)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.402e8cd127e086c8d21a6213785a5909.svg";
export { ForwardRef as ReactComponent };